import clsx from 'clsx';

import { ApplicationBar, Logo } from '@/components/Elements';
import { SIDE_NAVIGATION_MENU } from '@/globalConsts';

import { UserMenu } from '../UserMenu';

export type TopBarProps = {
	className?: string;
	isCollapsed: boolean;
};

export const TopBar = (props: TopBarProps) => {
	const { className, isCollapsed } = props;

	return (
		<ApplicationBar
			className={clsx(
				isCollapsed
					? `${SIDE_NAVIGATION_MENU.CALCULATED_WIDTH_PERCENT.EXPANDED} transition-width delay-100 duration-300 ease-in-out`
					: `${SIDE_NAVIGATION_MENU.CALCULATED_WIDTH_PERCENT.DEFAULT} transition-width delay-100 duration-300 ease-in-out`,
				className
			)}
		>
			<Logo />
			<UserMenu />
		</ApplicationBar>
	);
};
